export default __webpack_public_path__ + "static/media/object-team_darkGray2.0869bc8c.svg";